import { Component, OnDestroy, OnInit, Signal } from '@angular/core';
import { ContentComponent } from '../../../components/content/content.component';
import { CommonModule } from '@angular/common';
import { BreadcrumbsComponent } from '../../../common/breadcrumbs/breadcrumbs.component';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import {
  ApplicationAppEntityApplicationRead,
  ServiceAppEntityServiceRead, ShipmentAppEntityShipmentRead
} from '../../../openapi';
import {
  selectApplication,
  selectLoading,
  selectPending, selectShipments
} from '../../../store/selectors/application.selectors';
import {
  fakeSignApplication,
  loadApplication,
  loadPayments, loadRoadOccupationTypes, loadServiceAttachmentPositions, loadShipments,
  sendApplication, setApplication, setPayments, setShipments,
  signApplication
} from '../../../store/actions/application.actions';
import { selectServiceByUrl } from '../../../store/selectors/app.selectors';
import { SpinnerComponent } from '../../../common/spinner/spinner.component';
import {
  CarryingOutWorksPreviewComponent
} from '../application/carrying-out-works-application/carrying-out-works-preview/carrying-out-works-preview.component';
import { UploaderAttachmentsService } from '../../../services/uploader-attachments.service';
import {
  AlertContainerComponent,
  AlertService
} from '../../../common/alert-container/alert-container.component';
import {
  LocationReconstructionOfExitPreviewComponent
} from '../application/location-reconstruction-of-exit-application/location-reconstruction-of-exit-preview/location-reconstruction-of-exit-preview.component';
import {
  LocationOfDevicesUnrelatedToRoadPreviewComponent
} from '../application/location-of-devices-unrelated-to-road/location-of-devices-unrelated-to-road-preview/location-of-devices-unrelated-to-road-preview.component';
import {
  LocalisationDevicesUnrelatedToRoadPreviewComponent
} from '../application/localisation-devices-unrelated-to-road/localisation-devices-unrelated-to-road-preview/localisation-devices-unrelated-to-road-preview.component';
import {
  ApprovalOfTrafficOrganizationProjectsPreviewComponent
} from '../application/approval-of-traffic-organization-projects/approval-of-traffic-organization-projects-preview/approval-of-traffic-organization-projects-preview.component';
import {
  OpinionOnTheProjectOfTrafficOrgPreviewComponent
} from '../application/opinion-on-the-project-of-traffic-org/opinion-on-the-project-of-traffic-org-preview/opinion-on-the-project-of-traffic-org-preview.component';
import {
  PlacementAdvertisingPreviewComponent
} from '../application/placement-advertising/placement-advertising-preview/placement-advertising-preview.component';
import {
  CompensationForLossesPreviewComponent
} from '../application/compensation-for-losses/compensation-for-losses-preview/compensation-for-losses-preview.component';
import {
  OpinionOnIssuingADecisionPreviewComponent
} from '../application/opinion-on-issuing-a-decision/opinion-on-issuing-a-decision-preview/opinion-on-issuing-a-decision-preview.component';
import { PaymentStatusCheckerComponent } from '../../../common/payment-status-checker/payment-status-checker.component';
import {
  PublicInformationDisclosurePreviewComponent
} from '../application/public-information-disclosure/public-information-disclosure-preview/public-information-disclosure-preview.component';
import {
  NotificationGeneralRemarksRoadMarkingPreviewComponent
} from '../application/notification-general-remarks-road-marking/notification-general-remarks-road-marking-preview/notification-general-remarks-road-marking-preview.component';
import {
  ConsentReconstructionRenovationOfBuildingsPreviewComponent
} from '../application/consent-reconstruction-renovation-of-buildings/consent-reconstruction-renovation-of-buildings-preview/consent-reconstruction-renovation-of-buildings-preview.component';
import {
  DocumentsInformationPreviewComponent
} from '../application/documents-information/documents-information-preview/documents-information-preview.component';
import {
  GeneralLetterPreviewComponent
} from '../application/general-letter/general-letter-preview/general-letter-preview.component';
import {
  ResponseToCallPreviewComponent
} from '../application/response-to-call/response-to-call-preview/response-to-call-preview.component';
import {
  OccupationOfLanePlacementConstructionObjectsPreviewComponent
} from '../application/occupation-of-lane-placement-construction-objects/occupation-of-lane-placement-construction-objects-preview/occupation-of-lane-placement-construction-objects-preview.component';
import {
  TakeOverLaneReconstructionOfExitPreviewComponent
} from '../application/take-over-lane-reconstruction-of-exit/take-over-lane-reconstruction-of-exit-preview/take-over-lane-reconstruction-of-exit-preview.component';
import {
  PermitForOversizeVehiclesPreviewComponent
} from '../application/permit-for-oversize-vehicles/permit-for-oversize-vehicles-preview/permit-for-oversize-vehicles-preview.component';
import {
  NotificationOfEmergencyPreviewComponent
} from '../application/notification-of-emergency/notification-of-emergency-preview/notification-of-emergency-preview.component';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-approved-preview-page',
  standalone: true,
  imports: [
    ContentComponent,
    BreadcrumbsComponent,
    RouterModule,
    CommonModule,
    SpinnerComponent,
    CarryingOutWorksPreviewComponent,
    AlertContainerComponent,
    LocationReconstructionOfExitPreviewComponent,
    NotificationOfEmergencyPreviewComponent,
    LocationOfDevicesUnrelatedToRoadPreviewComponent,
    LocalisationDevicesUnrelatedToRoadPreviewComponent,
    ApprovalOfTrafficOrganizationProjectsPreviewComponent,
    OpinionOnTheProjectOfTrafficOrgPreviewComponent,
    PlacementAdvertisingPreviewComponent,
    CompensationForLossesPreviewComponent,
    OpinionOnIssuingADecisionPreviewComponent,
    PaymentStatusCheckerComponent,
    PublicInformationDisclosurePreviewComponent,
    NotificationGeneralRemarksRoadMarkingPreviewComponent,
    ConsentReconstructionRenovationOfBuildingsPreviewComponent,
    DocumentsInformationPreviewComponent,
    GeneralLetterPreviewComponent,
    ResponseToCallPreviewComponent,
    OccupationOfLanePlacementConstructionObjectsPreviewComponent,
    TakeOverLaneReconstructionOfExitPreviewComponent,
    PermitForOversizeVehiclesPreviewComponent
  ],
  providers: [UploaderAttachmentsService],
  templateUrl: './approved-preview-page.component.html'
})
export class ApprovedPreviewPageComponent implements OnInit, OnDestroy {
  public applicationId: string | undefined =
    this.route.snapshot.params['appId'];

  public signStatus: 'success' | 'canceled' | string | undefined =
    this.route.snapshot.params['signStatus'];

  public application: Signal<ApplicationAppEntityApplicationRead | null> =
    this.store$.selectSignal(selectApplication);

  public paymentToken: string | undefined = this.route.snapshot.queryParams['payum_token'] || this.route.snapshot.queryParams['amp;payum_token'];

  public canPay: boolean = !this.paymentToken;

  public contentUrl: string | undefined = this.route.snapshot.params['contentUrl'];

  public shipments: Signal<ShipmentAppEntityShipmentRead[]>
    = this.store$.selectSignal(selectShipments);

  public serviceType: Signal<ServiceAppEntityServiceRead | null> =
    this.store$.selectSignal(
      selectServiceByUrl(this.contentUrl || '')
    );

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  public production = environment.production;

  constructor(
    private store$: Store,
    private route: ActivatedRoute,
    private router: Router,
    private uploaderService: UploaderAttachmentsService,
    private alertService: AlertService
  ) {
  }

  public onPaymentComplete(): void {
    this.store$.dispatch(loadShipments({ applicationId: this.applicationId || '' }));
    this.canPay = true;
  }

  public fakeSign(): void {
    this.store$.dispatch(fakeSignApplication({
      applicationId: this.applicationId || '',
      successFnc: () => {
      },
      failureFnc: () => {
      }
    }));
  }

  public signApplication(): void {
    // to do
    // need to handle success or failure messages
    this.store$.dispatch(
      signApplication({
        applicationId: this.applicationId || '',
        successFnc: (redirectUrl: string) => {
          window.location.href = redirectUrl;
        },
        failureFnc: () => {
        }
      })
    );
  }

  public sendApplication(): void {
    this.store$.dispatch(sendApplication({
        applicationId: this.applicationId || '',
        successFnc: () => {
          this.router.navigate(
            ['/wnioski-wyslane' + this.application()?.service?.url, this.applicationId],
            {
              state: { message: 'applicationSent' }
            }
          );
        },
        failureFnc: () => {
        }
      })
    );
  }

  public onDownloadApplicationPdf(event: Event): void {
    const id = this.application()?.document?.id;
    const name = this.application()?.document?.originalName;
    event.preventDefault();
    event.stopPropagation();
    if (id && name) {
      this.uploaderService.downloadAttachment(id, name).toPromise().then();
    }
  }

  private handleMessages(): void {
    if (!!history.state?.message) {
      this.alertService.showByApplicationCode(history.state.message);
    }
    if (this.signStatus === 'success') {
      this.alertService.showByApplicationCode('applicationSigned');
    }
    if (this.signStatus === 'canceled') {
      this.alertService.showByApplicationCode('applicationNotSigned');
    }
  }

  public ngOnInit(): void {
    this.handleMessages();

    this.store$.dispatch(loadApplication({ id: this.applicationId || '' }));
    this.store$.dispatch(loadPayments({ applicationId: this.applicationId || '' }));
    this.store$.dispatch(loadShipments({ applicationId: this.applicationId || '' }));
    this.store$.dispatch(loadRoadOccupationTypes());
    this.store$.dispatch(loadServiceAttachmentPositions({ appId: this.applicationId || '' }));
  }

  public ngOnDestroy(): void {
    this.store$.dispatch(setApplication({ application: null }));
    this.store$.dispatch(setPayments({ applicationPayment: null }));
    this.store$.dispatch(setShipments({ shipments: [] }));
  }
}
